// fr strings for messages/pricing.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const pricing: Dict = {
  "pricing.promo": "Ton premier mois à partir de {price}",
  "pricing.title": "Fais des covers avec n'importe quelle voix",
  "pricing.subtitle":
    "Covers illimitées, téléchargements et plus de 93 000 voix. Annule quand tu veux.",
  "pricing.trialLinkInvalid":
    "Ce lien d'essai gratuit est lié à un autre compte ou a expiré. Voici le paiement classique.",
  "pricing.basic.subtitle": "Pour faire des covers",
  "pricing.creator.subtitle": "Pour les vidéos et tes propres voix",
  "pricing.power.subtitle": "Pour un usage intensif et les développeurs",
  "pricing.badge.popular": "Le plus populaire",

  "pricing.feature.unlimitedCovers": "Covers illimitées",
  "pricing.feature.download": "Télécharge la cover, la voix et la musique",
  "pricing.feature.library": "Toute la bibliothèque de voix",
  "pricing.feature.tts": "Synthèse vocale",
  "pricing.feature.duets": "Duos",
  "pricing.feature.credits": "Tes crédits n'expirent jamais",
  "pricing.feature.train": "Entraîne des voix en illimité",
  "pricing.feature.videos": "Vidéos à partager : Marble Run et paroles",
  "pricing.feature.coins50": "50 pièces vidéo chaque mois",
  "pricing.feature.priority":
    "Traitement prioritaire, 250 toutes les 12 heures",
  "pricing.feature.coinsUnlimited": "Pièces vidéo illimitées",
  "pricing.feature.api": "$25 de crédits API chaque mois",
  "pricing.compareAll": "Tout comparer",

  "pricing.trust.cancel": "Annule quand tu veux, garde ce que tu as créé",
  "pricing.trust.stripe": "Paiement sécurisé avec Stripe",
  "pricing.trust.currency": "Prix dans ta devise",

  "pricing.compare.title": "Compare les abonnements",
  "pricing.compare.noPlan": "Sans abonnement",
  "pricing.compare.browse": "Explorer et écouter toutes les voix",
  "pricing.compare.covers": "Covers",
  "pricing.compare.downloads": "Téléchargements",
  "pricing.compare.ttsDuets": "Synthèse vocale et duos",
  "pricing.compare.song": "Générer une chanson avec l'IA",
  "pricing.compare.train": "Entraîner tes propres voix",
  "pricing.compare.videos": "Vidéos (Marble Run, paroles)",
  "pricing.compare.priority": "Traitement prioritaire",
  "pricing.compare.api": "Crédits API",
  "pricing.compare.unlimited": "Illimité",
  "pricing.compare.coins50": "50 pièces par mois",
  "pricing.compare.priorityLimit": "250 toutes les 12 heures",
  "pricing.compare.apiAmount": "$25 par mois",

  "pricing.faq.title": "Questions",
  "pricing.faq.noPlan.q": "Que puis-je faire sans abonnement ?",
  "pricing.faq.noPlan.a":
    "Tu peux explorer et écouter toutes les voix de Jammable. Pour faire des covers, les télécharger, utiliser la synthèse vocale et les duos, il te faut un abonnement.",
  "pricing.faq.basic.q": "Que comprend l'abonnement Basic ?",
  "pricing.faq.basic.a":
    "L'abonnement Basic comprend les covers illimitées, les téléchargements, l'accès à toute la bibliothèque de voix Jammable, la synthèse vocale et les duos, et tes crédits n'expirent jamais.",
  "pricing.faq.creator.q": "Quelle différence entre Creator et Basic ?",
  "pricing.faq.creator.a":
    "Creator comprend tout ce qu'offre Basic, plus l'entraînement de voix en illimité, les vidéos à partager et 50 pièces Marble Run par mois.",
  "pricing.faq.power.q": "Qu'est-ce que l'abonnement Power a de plus ?",
  "pricing.faq.power.a":
    "Power comprend tout ce qu'offre Creator, plus le traitement prioritaire (250 toutes les 12 h), des pièces Marble Run illimitées et $25 de crédits API chaque mois, pour les créateurs pros.",
  "pricing.faq.cancel.q": "Puis-je annuler mon abonnement à tout moment ?",
  "pricing.faq.cancel.a":
    "Oui, tu peux annuler quand tu veux. Tes avantages restent actifs jusqu'à la fin de ta période de facturation.",
  "pricing.faq.change.q":
    "Puis-je passer à un abonnement supérieur ou inférieur ?",
  "pricing.faq.change.a":
    "Bien sûr. Change d'abonnement quand tu veux et tes avantages s'adaptent automatiquement.",

  "pricing.card.perYear": "par an, soit environ {price} par mois",
  "pricing.card.firstMonthThen": "le premier mois, puis {price} par mois",
  "pricing.card.perMonth": "par mois",
  "pricing.card.startFor": "Commence pour {price}",
  "pricing.card.everythingIn": "Tout ce qu'offre {plan}, plus",

  "pricing.cta.get": "Choisir {plan}",
  "pricing.cta.yourPlan": "Ton abonnement",
  "pricing.cta.manage": "Gérer l'abonnement",
  "pricing.cta.upgradeTo": "Passer à {plan}",
  "pricing.cta.updated": "Ton abonnement a été mis à jour !",
  "pricing.error.generic": "Une erreur est survenue. Contacte le support !",

  "pricing.seo.title": "Tarifs | Jammable",
  "pricing.seo.description":
    "Les abonnements Jammable pour faire des covers IA avec n'importe quelle voix : covers illimitées, téléchargements et plus de 93 000 voix. Prix dans ta devise, sans engagement.",
};

export default pricing;
